export default { accessToken: '8c366b91e019521784f4aa661f10818eb0d4a0346c97710ae6de4c0a837f5246' }
